export const tabIndexMap: any = {
  1: "Top Selling",
  2: "Replacement parts",
  3: "Lighting",
  4: "Body Parts",
  5: "Wheels and Tires",
  6: "Tools",
  7: "Performance",
  8: "Interior",
  9: "Exterior",
  10: "Specialty Parts",
};
